import React from "react";

export const GRONCARD_LOGO_PATH = "/Groncard.jpg";

// Groncard.jpg has large built-in white padding; Greencart.png fills its canvas.
export const GRONCARD_TYPE_ICON_SCALE = 1.35;
// h-5 (1.25rem) × scale — use explicit size instead of CSS transform so
// RawTransfersTable scroll perf rule (.v3-raw-scroll img { transform: none }) cannot strip it.
export const GRONCARD_TYPE_ICON_SIZE_CLASS = "h-[1.6875rem] w-[1.6875rem]";

export function isGroncardRow(tx = {}, clsRaw = "") {
  const cls = String(clsRaw || tx?.classification || tx?.type || "")
    .trim()
    .toLowerCase();

  const application = String(tx?.application || "").trim().toLowerCase();
  const appSlug = String(tx?.x2earnAppSlug || "").trim().toLowerCase();
  const cashbackProgram = String(tx?.cashbackProgram || "").trim().toLowerCase();
  const rewardKind = String(tx?.x2earnRewardKind || "").trim().toLowerCase();

  return (
    cls === "groncard_gift_card_purchase" ||
    cls === "groncard_payment_confirmation" ||
    application === "groncard" ||
    appSlug === "groncard" ||
    cashbackProgram === "groncard_gift_card_cashback" ||
    rewardKind === "groncard_gift_card_cashback" ||
    tx?.groncardGiftCardRewardConfirmed === true ||
    tx?.groncardGiftCardPurchaseConfirmed === true ||
    tx?.groncardPaymentMarkerConfirmed === true
  );
}

export function isGroncardGiftCardPurchase(clsRaw = "") {
  return String(clsRaw || "").trim().toLowerCase() === "groncard_gift_card_purchase";
}

export function isGroncardCashbackRow(tx = {}, clsRaw = "") {
  const cls = String(clsRaw || tx?.classification || tx?.type || "")
    .trim()
    .toLowerCase();
  return cls === "purchase_cashback" && isGroncardRow(tx, cls);
}

export function formatGroncardSubtitle(clsRaw = "", language = "de") {
  const cls = String(clsRaw || "").trim().toLowerCase();

  if (cls === "groncard_gift_card_purchase") {
    return language === "de" ? "Gutschein-Kauf" : "Gift Card Purchase";
  }

  if (cls === "purchase_cashback") {
    return "Cashback";
  }

  if (cls === "groncard_payment_confirmation") {
    return language === "de" ? "Zahlungsbestätigung" : "Payment Confirmation";
  }

  return language === "de" ? "Groncard" : "Groncard";
}

export function GroncardTypeIcon({ className = "mt-0.5" } = {}) {
  return (
    <div
      className={`flex ${GRONCARD_TYPE_ICON_SIZE_CLASS} flex-shrink-0 items-center justify-center overflow-visible ${className}`}
    >
      <img
        src={GRONCARD_LOGO_PATH}
        alt="Groncard"
        className={`${GRONCARD_TYPE_ICON_SIZE_CLASS} max-w-none object-contain`}
        draggable={false}
        loading="lazy"
        decoding="async"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    </div>
  );
}

export default function GroncardTypeLabel({
  tx = {},
  classification = "",
  language = "de",
  leading = null,
  titleClassName = "text-blue-600 font-semibold",
  subtitleClassName = "text-[11px] font-medium text-blue-700/90",
}) {
  const cls = String(classification || tx?.classification || tx?.type || "")
    .trim()
    .toLowerCase();
  const subtitle = formatGroncardSubtitle(cls, language);

  return (
    <div className={`flex items-start gap-2 min-w-0 ${titleClassName}`}>
      {leading != null ? (
        <span className="mt-0.5 shrink-0" aria-hidden>
          {leading}
        </span>
      ) : null}

      <GroncardTypeIcon />

      <div className="min-w-0 leading-tight text-left">
        <div className="whitespace-normal break-words">Groncard</div>
        <div className={`whitespace-normal break-words ${subtitleClassName}`}>
          {subtitle}
        </div>
      </div>
    </div>
  );
}
